/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Vu Dinh Luan (vdluan@rsupport.com)
 *
 * @description
 *
 * @created at Fri Sep 13 2024
 **/

import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { Column, Icon, Row, Typography } from "@/frameworks/designStuff/components";

export const ViewerWrap = styled(Column)`
	width: 100vw;
	height: 100vh;
	position: relative;
	background-color: ${({ theme }) => theme.colors.neutral_00_100};
	overflow: hidden;
`;

export const Content = styled(Row.div)`
	padding: 20px;
	display: flex;
	flex-direction: column;
`;

export const UploadWrap = styled(Row.div)`
	flex-direction: row;
	gap: 12px;
`;

export const ImageBox = styled(Row.div)`
	position: relative;
	cursor: pointer;
	width: 80px;
	height: 80px;
	border-radius: 12px;
	display: flex;
	background: ${({ bgcolor }: { bgcolor: string }) => bgcolor};
	align-items: center;
	justify-content: center;
	/* overflow: hidden; */
`;

export const Img = styled.img`
	width: 100%;
	height: 100%;
	border-radius: 12px;
	object-fit: cover;
`;

export const ImgRemoveButton = styled.div`
	position: absolute;
	top: 2px;
	right: 2px;
	width: 22px;
	height: 22px;
	background: rgba(0, 0, 0, 0.3);
	display: flex;
	align-items: center;
	justify-content: center;
	color: ${({ theme }) => theme.colors.neutral_00_100};
	font-size: 10px;
	border-radius: 50%;
	cursor: pointer;
`;

export const EmptyUploadWrapper = styled(Column)`
	width: 100%;
	height: 100%;
	background: ${({ theme }) => theme.colors.neutral_00_100};
	border: 1px solid ${({ theme }) => theme.colors.neutral_30_100};
	border-radius: 12px;
`;

export const EmptyImgIcon = styled(Icon)`
	fill: ${({ theme }) => theme.colors.neutral_00_100};
`;

export const NameTypo = styled(Typography.p)`
	padding: 8px 4px;
	width: 72px;
	color: ${({ theme }) => theme.colors.neutral_00_100};
	word-break: break-all;
	display: -webkit-box;
	-webkit-line-clamp: 3;
	-webkit-box-orient: vertical;
	overflow: hidden;
	width: 100%;
	text-align: center;
`;

export const FieldBox = styled(Row.div)`
	width: 100%;
	flex-direction: column;
`;

export const KeywordWrapper = styled(Row.div)`
	width: 100%;
	max-width: 376px;
`;

export const Name = styled(Typography.p)`
	margin: 0 0 5px 0;
	color: ${({ theme }) => theme.colors.neutral_60_100};
`;

export const HelpText = styled(Typography.p)`
	color: ${({ theme }) => theme.colors.neutral_60_100};
`;

export const FooterContent = styled(Row.div)`
	height: 56.45px;
	font-weight: 500;
	font-size: 14px;
	line-height: 20px;
	padding: 40px 14px;
`;

export const ColorPreview = styled.div<{ color: string }>`
	width: 18px;
	height: 18px;
	background: ${({ color }) => color};
	border-radius: 16px;
	cursor: pointer;
`;

export const FakeInput = styled.input`
	opacity: 0;
	position: absolute;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	cursor: pointer;
	::-webkit-file-upload-button {
		cursor: pointer;
	}
`;

export const FakeRadioWrapper = styled(Row.div)`
	position: relative;
`;

export const UploadText = styled(Typography.p)`
	color: ${({ theme }) => theme.colors.neutral_80_50};
`;

export const marginBottomStyle = (data: number) => css`
	margin-bottom: ${data}px;
`;

export const colorTypo = (color: string) => css`
	color: ${color};
`;

export const menuWrapperStyle = () => css`
	width: 284px;
`;

export const menuListStyle = css`
	display: flex;
	flex-direction: row;
	gap: 4px;

	align-content: flex-start;
	flex-direction: row;
	flex-wrap: wrap;
`;

export const radioStyle = css`
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
`;

export const uploadStyle = css`
	margin: 0 0 0 12px;
`;

export const IconWrapper = styled(Row.label)`
	position: absolute;
	cursor: pointer;
	bottom: -6px;
	right: -6px;
	background-color: ${({ theme }) => theme.colors.accent_20_100};
	border-radius: 50%;
	height: 28px;
	width: 28px;
	justify-content: center;
	align-items: center;
`;
